<template>
  <div class="price">
    <div class="container">
      <div v-html="priceList" class="content"></div>
    </div>
  </div>
</template>

<script>
import {reqFullText} from '../../api'
export default {
  data() {
    return {
      priceList: ''
    }
  },
  created() {
    reqFullText('008').then(res => {
      if(res.code == 200) {
        this.priceList = res.data.bussData.msgContent
      }
    })
  }
}
</script>

<style scoped lang="less" type="text/less">
.price{
  .content{
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Price/Price.vue